import { getParamByName, getRuntimeConfig } from '../config';
import { getCachedAuthToken } from '../helpers/auth';
import { getLocale } from '../helpers/locale';

function isTrue(value) {
    return value === true || value === 'true';
}

function isTeacherTotterEnabled(environment, config) {
    return (
        environment === 'prod' &&
        isTrue(config.TeacherTotterEnabled) &&
        getParamByName('isOneRosterActivatedSchool') === 'true'
    );
}

export function getAnalyticsBuildConfig() {
    const config = getRuntimeConfig();
    const environment = config.env;

    return {
        environment,
        posthogEnabled: isTrue(config.PostHogEnabled),
        trackingGroups: config.PostHogTrackingGroups,
        teacherTotterEnabled: isTeacherTotterEnabled(environment, config),
        teacherTotterSyncUrl: config.AnalyticsTeacherTotterSyncUrl,
        identityGatewayUrl: config.AnalyticsIdentityGatewayUrl,
        getAppAuthToken: getCachedAuthToken
    };
}

export function getAnalyticsIdentity() {
    return {
        locale: getLocale(),
        countryCode: getParamByName('countryCode') || '',
        userProfileId: getParamByName('userProfileId') || '',
        userProfileType: 'teacher',
        marketRegionId: getParamByName('regionId') || ''
    };
}
